/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateTaskProgressCommand } from '../../models/create-task-progress-command';
import { CreateTaskProgressCommandResult } from '../../models/create-task-progress-command-result';

export interface ApiTaskProgressCreateTaskProgressPost$Plain$Params {
      body?: CreateTaskProgressCommand
}

export function apiTaskProgressCreateTaskProgressPost$Plain(http: HttpClient, rootUrl: string, params?: ApiTaskProgressCreateTaskProgressPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateTaskProgressCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiTaskProgressCreateTaskProgressPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateTaskProgressCommandResult>;
    })
  );
}

apiTaskProgressCreateTaskProgressPost$Plain.PATH = '/api/TaskProgress/CreateTaskProgress';
